"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateOrderLineVersion = void 0;
const cloneObject_1 = require("../cloneObject");
const updateOrderLineVersion = async (supabase, order_line_version) => {
    const obj = (0, cloneObject_1.cloneObject)(order_line_version);
    delete obj.id;
    delete obj.created_at;
    delete obj.regions;
    delete obj.order_lines;
    delete obj.created_by_user;
    const { data, error } = await supabase
        .from("order_line_versions")
        .insert(obj)
        .single();
    // update the order_line latest_version_id to the new version id
    if (data) {
        await supabase
            .from("order_lines")
            .update({ latest_version_id: data.id })
            .eq("id", order_line_version.order_line_id);
    }
    if (error) {
        throw new Error(error.message);
    }
    return data;
};
exports.updateOrderLineVersion = updateOrderLineVersion;
